import React from 'react';
import T from 'prop-types';

import PageNav from './PageNav';
import Container from '../../../components/Container';

import { predefinedPage } from '../configs';

const PageHeader = ({ currentPage, onPageChange }) =>
  predefinedPage === 'exports' ? null : (
    <header className="reports-and-exports-page__header">
      <Container gutters={32}>
        <div className="reports-and-exports-page__header-top">
          <h1 className="h3 text-black">Research & Data</h1>
        </div>
        <div className="reports-and-exports-page__header-bottom">
          <PageNav active={currentPage} onChange={onPageChange} />
        </div>
      </Container>
    </header>
  );

PageHeader.propTypes = {
  currentPage: T.string.isRequired,
  onPageChange: T.func.isRequired,
};

export default PageHeader;
